// 지그·3D 모델 설정 값 다루기 (순수 함수 — 시험용, 2026-11-02 계획_3D모델_전체공개_웹설정)
//   labSettings/{labId}.jigSettings = { cementGap, holeClearance, articulator, autoOn, autoModel }.
//   덴클 프로그램(에이전트 jig-roundtrip.js normalizeWebSettings)도 같은 규칙으로 읽는다 — 범위 밖 숫자는 기본값.
//   대표 11-02 "에이전트 조정값 칸 없애고 전부 웹으로".
export const ARTICULATOR_OPTIONS = [
    ['block', '끝블록 (앞뒤 끝 맞물림)'],
    ['support', '지지 핀'],
    ['pin', '핀 힌지'],
    ['snap', '딸깍'],
    ['magnet', '자석'],
    ['none', '없음'],
];
// 숫자 범위 = 에이전트 OPTION_LIMITS·서버 jig-queue sanitizeMeta 와 같다 [최소, 최대, 기본]
export const NUM_LIMITS = { cementGap: [0.01, 0.5, 0.06], holeClearance: [0, 1.0, 0.3] };
export const DEFAULT_JIG_SETTINGS = { cementGap: 0.06, holeClearance: 0.3, articulator: 'block', autoOn: false, autoModel: false };   // 끝블록(10-28) · 자동 끔 · 자동 모델 끔(11-02 대표 추천안)

export function normalizeJigSettings(v) {
    const o = v && typeof v === 'object' ? v : {};
    const out = {};
    for (const [k, [lo, hi, def]] of Object.entries(NUM_LIMITS)) {
        const n = Number(o[k]);
        out[k] = (o[k] !== '' && o[k] != null && Number.isFinite(n) && n >= lo && n <= hi) ? n : def;
    }
    out.articulator = ARTICULATOR_OPTIONS.some(([k]) => k === o.articulator) ? o.articulator : DEFAULT_JIG_SETTINGS.articulator;
    out.autoOn = o.autoOn === true;
    out.autoModel = o.autoModel === true;
    return out;
}
